import type { Bonus, PreviewPage, Volume } from '../types/content';

export const capabilities = ['Saber qué vas a comer antes de que llegue la hora de decidir', 'Comprar solamente lo que necesitás para tu planificación', 'Aprovechar una sesión de cocina para adelantar varias comidas', 'Abrir el freezer y encontrar opciones listas para usar'];

export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'PLAN SEMANAL RESUELTO™',
  subtitle: 'Organizá tus comidas antes de que empiece la semana.',
  items: ['Definís tus comidas antes de que llegue el caos', 'Armás un plan según tus días y necesidades', 'Convertís el menú en una lista de compras', 'Organizás cantidades y porciones', 'Tenés un plan de emergencia para días complicados'],
  result: '“Tengo un plan.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'COCINA POR TANDAS™',
  subtitle: 'Aprendé a aprovechar una sesión de cocina para adelantar varias comidas.',
  items: ['Preparás varias comidas en una misma sesión', 'Combinás proteínas, bases y vegetales', 'Organizás las tareas en un orden práctico', 'Armás porciones listas para guardar', 'Reducís la necesidad de cocinar desde cero todos los días'],
  result: '“Tengo las comidas preparadas.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'FREEZER INTELIGENTE™',
  subtitle: 'Convertí tu freezer en una reserva de comidas organizada y fácil de usar.',
  items: ['Sabés qué guardar y cómo organizarlo', 'Dividís el freezer por zonas y categorías', 'Etiquetás de forma clara', 'Organizás porciones fáciles de encontrar', 'Aplicás una rotación para saber qué usar primero'],
  result: '“Sé qué tengo, dónde está y qué debería usar.”',
  accent: 'highlight'
}, {
  label: 'VOLUMEN 04',
  title: 'SEMANA RESUELTA™',
  subtitle: 'Llevá todo el sistema a tu semana real.',
  items: ['Organizás semanas prácticas según tu rutina', 'Tenés alternativas para semanas económicas', 'Resolvé mejor las comidas cuando tenés poco tiempo', 'Contás con opciones para viandas y semanas express', 'Creás un banco de semanas reutilizables'],
  result: '“Tengo una semana lista para implementar.”',
  accent: 'danger'
}];

export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/ocoDf7CwdLd9UbAM8AnR5c/Hoja_1.webp',
  alt: 'Página del pack: Una semana. Cuatro pasos.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oLMp5H4unA7FFPBQwwM2xD/Hoja_2.webp',
  alt: 'Página del pack: Construí comidas sin empezar de cero. La Matriz de Comidas.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3wdLRDaVzz686RVU19DPRG/Hoja_3.webp',
  alt: 'Página del pack: La Regla 2+2+2.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/b2rUaBWwBi8GDN3mN8qLqD/Hoja_4.webp',
  alt: 'Página del pack: Organizar no significa comer lo mismo.'
}];

export const bonuses: Bonus[] = [{
  number: '01',
  title: 'MAPA DEL FREEZER™',
  detail: 'Una herramienta visual para saber rápidamente qué tenés guardado y qué deberías usar primero.',
  items: ['Visualizás rápidamente lo que tenés almacenado', 'Organizás por zonas según el tipo de alimento', 'Registrás cantidades y porciones', 'Priorizás lo que necesitás usar primero', 'Mantenés el freezer organizado con revisiones simples'],
  value: '$12.000'
}, {
  number: '02',
  title: 'LISTA DE COMPRAS INTELIGENTE™',
  detail: 'Transformá tu planificación semanal en una lista de compras clara y práctica.',
  items: ['Empezás por lo que ya tenés', 'Organizás la compra por categorías', 'Definís cantidades', 'Evitás compras innecesarias', 'Usás un checklist simple'],
  value: '$10.000'
}, {
  number: '03',
  title: 'DOMINGO DE COCINA™',
  detail: 'Una estructura práctica para preparar varias cosas en una misma sesión.',
  items: ['Preparás todo antes de empezar', 'Organizás tu estación de trabajo', 'Definís el orden de producción', 'Aprovechás tareas en paralelo', 'Porcionás, etiquetás y guardás'],
  value: '$9.000'
}, {
  number: '04',
  title: 'KIT ANTI-DESPERDICIO™',
  detail: 'Ideas y herramientas para aprovechar mejor lo que ya tenés.',
  items: ['Identificás alimentos que necesitás usar', 'Transformás sobras en nuevas preparaciones', 'Combinás pequeñas cantidades', 'Priorizás alimentos próximos a vencer', 'Tenés planes para rescatar ingredientes'],
  value: '$11.000'
}, {
  number: '05',
  title: 'PLAN SALVAVIDAS™',
  detail: 'Opciones para esos días en los que simplemente no tenés tiempo.',
  items: ['Comidas en 5, 10 y 15 minutos', 'Combinaciones de freezer + base + proteína', 'Alternativas para días sin tiempo', 'Opciones para cuando no tenés ganas de cocinar', 'Stock mínimo para emergencias'],
  value: '$10.000'
}];
